// Post-login / post-signup return target from ?redirect= (or ?next=). Only same-origin relative
// paths are accepted ("/checkout", "/listing/abc?x=1"); anything else (absolute or
// protocol-relative URLs, backslash tricks, javascript:, control characters, or a loop back to
// /login or /signup) falls back, so the param cannot be used as an open redirect.

const BASE = 'https://cherrypkd.invalid';
const LOOP_PATHS = /^\/(login|signup)\/?$/i;

export function safeRedirect(raw, fallback = '/dashboard') {
  if (typeof raw !== 'string') return fallback;
  const v = raw.trim();
  if (!v || v[0] !== '/' || v[1] === '/' || v.includes('\\')) return fallback;
  if (/[\u0000-\u001f\u007f]/.test(v)) return fallback;
  let u;
  try { u = new URL(v, BASE); } catch { return fallback; }
  if (u.origin !== BASE) return fallback;
  if (LOOP_PATHS.test(u.pathname)) return fallback;
  return `${u.pathname}${u.search}${u.hash}`;
}

export function getSafeRedirect(searchParams, fallback = '/dashboard') {
  const raw = searchParams?.get?.('redirect') ?? searchParams?.get?.('next') ?? null;
  return safeRedirect(raw, fallback);
}

// "/signup" or "/login" carrying the (validated) return target along.
export function authPathWithRedirect(path, searchParams) {
  const target = getSafeRedirect(searchParams, '');
  return target ? `${path}?redirect=${encodeURIComponent(target)}` : path;
}
